import { render } from "./LoadingOrderList.vue?vue&type=template&id=855964b6&scoped=true"
import script from "./LoadingOrderList.vue?vue&type=script&lang=js"
export * from "./LoadingOrderList.vue?vue&type=script&lang=js"

import "./LoadingOrderList.vue?vue&type=style&index=0&id=855964b6&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855964b6"]])

export default __exports__